import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()
window.App = window.App || {}
window.App.cable = consumer
window.ActionCable = window.ActionCable || {}
window.ActionCable.createConsumer = createConsumer

export default consumer
